'use strict';

const AppDispatcher = require('dispatcher/SchedulerAppDispatcher'),
  React = require('react'),
  { t } = require('services/i18nextWrapper'),
  CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
  Loading = require('components/Commons/Loading/Loading'),
  Notification = require('components/Notification/Notification'),
  UserTaskStore = require('stores/UserTaskStore'),
  NumberUtils = require('utils/NumberUtils'),
  ChronologycServiceCache = require('services/ChronologycServiceCache'),
  ContextMenuEl = require('components/Commons/ContextMenuCustom/ContextMenuEl'),
  CustomOverlay = require('components/CustomOverlay/CustomOverlay'),
  UserTasks = require('components/UserTask/UserTask'),
  InventoryReport = require('components/InventoryReport/InventoryReport'),
  moment = require('moment'),
  Router = require('react-router'),
  DashboardCache = require('./DashboardCache'),
  get = require('lodash/object').get,
  { delay } = require('lodash/function'),
  { map, filter, find, some, forEach } = require('lodash/collection'),
  { union } = require('lodash/array'),
  Authentication = require('services/Security').Authentication,
  DashboardActionCreators = require('actions/DashboardActionCreators'),
  // ga = require('react-ga'),
  ga = {
    modalview: () => {
    },
    pageview: () => {
    },
    event: () => {
    }
  },
  DashboardViewOnlyIndicator = require('./DashboardViewOnlyIndicator'),
  categories = require('constants/AppConstants').Analytics.categories,
  actions = require('constants/AppConstants').Analytics.actions,
  labels = require('constants/AppConstants').Analytics.labels,
  ActionTypes = require('constants/AppConstants').ActionTypes,
  ReactGridLayout = require('react-grid-layout'),
  DateUtils = require('utils/DateUtils'),
  ContentUtils = require('utils/ContentUtils'),
  OrderUtils = require('utils/OrderUtils'),
  PositionUtils = require('utils/PositionUtils'),
  BrowserUtils = require('utils/BrowserUtils'),
  Viewport = require('utils/Viewport'),
  PollerDashboard = require('pollers/PollerDashboard'),
  PollerSaveDraft = require('pollers/PollerSaveDraft'),
  PollerSaveNote = require('pollers/PollerSaveNote'),
  DashboardServiceImpl = require('services/DashboardServiceImpl'),
  PollerAppVersion = require('pollers/PollerAppVersion'),
  SessionStore = require('stores/SessionStore'),
  DashboardStore = require('stores/DashboardStore'),
  InventoryStore = require('stores/InventoryStore'),
  TankStore = require('stores/TankStore'),
  DashboardServiceCache = require('services/DashboardServiceCache'),
  ChronologycStore = require('stores/ChronologycStore'),
  OrderStore = require('stores/OrderStore'),
  ChronologycBar = require('components/Chronologyc/Chronologyc'),
  UIStateStore = require('stores/UIStateStore'),
  Immutable = require('immutable'),
  {
    ROW_HIGHT,
    DATE_FORMAT,
    DEFAULT_MONTH_BEFORE,
    DEFAULT_MONTH_AFTER,
    TASK_NON_VISIBLE,
    DEFAULT_DAYS_AFTER,
    DEFAULT_DAYS_BEFORE,
    DAYS_BACKWARD_FORWARD,
    INVENTORY_MAX_PAST_DAYS_SCOPE
  } = require('constants/AppConstants'),
  mui = require('material-ui'),
  { FloatingActionButton, FlatButton, Dialog } = mui,
  propsToValiadte = ['x', 'y', 'i', 'h'],
  BREAK_POINTS_DASHBOARD = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 30 };

let initialResizing,
  isDashboardAlreadyFreezed = false,
  scrollingAdjustInProgress = false,
  /**
   * The visible array of positions which is visible into the dashboard.
   * @type {Array}
   */
  visibleLayoutOrders = [];

require('./Dashboard.scss');

moment.locale(localStorage.getItem('i18nextLng'));

function ShowNotificationShouldExistOneTankPerSection() {
  return (
    React.createElement("div", {className: "text-center jumbotron", 
      style: {
        paddingTop: '10%',
        margin: '0 auto',
        position: 'absolute',
        width: '100%',
        height: '100%'
      }}, 
      React.createElement("p", null, t('dashboard_notification_check_tank_configuration_profile'))
    )
  );
}

const Dashboard = React.createClass({displayName: "Dashboard",

  mixins: [Authentication, Router.Navigation],

  contextTypes: {
    router: React.PropTypes.func
  },

  /**
   * Current position of dashboard.
   */
  positions: {
    start: null,
    stop: null
  },

  isStopByPromptConfirm: false,

  getInitialState() {
    const dateReference = moment().format(DATE_FORMAT), // to day
      rangeFrom = moment(dateReference, DATE_FORMAT).subtract(DEFAULT_MONTH_BEFORE, 'month').subtract(DEFAULT_DAYS_BEFORE, 'days').format(DATE_FORMAT),
      rangeTo = moment(dateReference, DATE_FORMAT).add(DEFAULT_MONTH_AFTER, 'month').add(DEFAULT_DAYS_AFTER, 'days').format(DATE_FORMAT);

    ChronologycStore.setCurrentRange(rangeFrom, rangeTo);
    DashboardStore.forceRenderDashboard();

    return {
      isVisibleBeerStyleLabelBrewing: SessionStore.isVisibleBeerStyleLabelBrewing(),
      isVisibleBeerStyleLabelFermenting: SessionStore.isVisibleBeerStyleLabelFermenting(),
      isVisibleBeerStyleLabelPackaging: SessionStore.isVisibleBeerStyleLabelPackaging(),
      from: ChronologycStore.getCurrentFrom(),
      to: ChronologycStore.getCurrentTo(),
      rangeOfDate: ChronologycStore.getCurrentRangeOfDate(),
      dateReference: dateReference,
      isPublishedDisabled: DashboardStore.hasPendingSavedDraftWithoutPublish(),
      isDashboardBackwardForwarePristine: true,
      immCurrentLayout: Immutable.List([]),
      shouldRender: DashboardStore.isNeedForceRenderDashboard(),
      isSearchExpand: false,
      isInventoryReportVisible: false,
      isUserTaskVisible: false,
      currentDate: DateUtils.getCurrentDate(),
      userTaskDate: DateUtils.getCurrentDate(),
      itemSearchTarget: null,
      isFilterModeActivated: false,
      filterToggleChange: false,
      items: [],
      isCalculatingInventory: DashboardStore.getIsCalculatingInventory() === '' ? true : DashboardStore.getIsCalculatingInventory(), // '' is the default state of first time.
      minDateInventory: DateUtils.getByDateFromNowInDays(-INVENTORY_MAX_PAST_DAYS_SCOPE)
    };
  },

  componentWillMount() {
    document.getElementsByTagName('body')[0].classList.add('is-overflow-hidden'); // Fix material side effect on calendars of modal orders
    UIStateStore.addChangeListener(this._onChangeUI);
    DashboardStore.addChangeListener(this._onChange);
    OrderStore.addChangeListener(this._onChange);
    OrderStore.markOrderListener(this._markOrder);

    const maxScopeInventoryDate = moment().add(-INVENTORY_MAX_PAST_DAYS_SCOPE, 'days').format(DATE_FORMAT);
    SessionStore.setMaxScopeInventoryDate(maxScopeInventoryDate);

    const isGuestUser = !SessionStore.isAdminUser();
    this.setState({
      isGuestUser,
      maxScopeInventoryDate,
      isAbleToEditDates: SessionStore.isAbleToEditDates(),
      isAbleToEditAllWithoutDates: SessionStore.isAbleToEditAllWithoutDates()
    });
  },

  componentWillUnmount() {
    // remove listeners
    document.getElementsByTagName('body')[0].classList.remove('is-overflow-hidden');// Fix material side effect on calendars of modal orders
    UIStateStore.removeChangeListener(this._onChangeUI);
    DashboardStore.removeChangeListener(this._onChange);
    OrderStore.removeChangeListener(this._markOrder);

    // remove the interval of scroll watcher
    if (this.intervalCheckScrollWatcher) {
      clearInterval(this.intervalCheckScrollWatcher);
    }

    // close context menu in case that are open
    ContextMenuEl.close();

    // stop all poller
    PollerSaveNote.stop();
    PollerDashboard.stop();
    PollerSaveDraft.stop();
    PollerAppVersion.stop();
  },

  shouldComponentUpdate(nextProps, nextState) {
    return this._shouldRenderDashboard(nextState);
  },

  componentDidMount() {
    ga.pageview('/dashboard');

    if (!SessionStore.isCalculatingInventory()) {
      // enter the first time, to set default value.
      SessionStore.setIsCalculatingInventory(true);
    }
    const { from, to } = this.state;

    // register the scroll watcher which allow to
    // auto loading the new range when it rich one of the border (top/bottom)
    // of the dashboard which turn visible the spinner of the dashboard.
    this._registerScrollWatcher();
    const self = this;

    DashboardStore.fetchDashboardContent(from, to, SessionStore.getCurrentApplicant(), function onFetchDashboardContentSuccess() {
      self._onChange();
      self._setScrollPositionOnToday();
    });

    PollerAppVersion.start();
    PollerDashboard.start();
    PollerSaveDraft.start();
    PollerSaveNote.start();
  },

  componentWillUpdate() {
    ChronologycStore.setCurrentRange(this.state.from, this.state.to);
  },

  componentDidUpdate() {
    this._fireResize();
    const needToHydrateDashboardLayout = !DashboardStore.isInitializedLayoutDashboard() && get(this.refs, 'dashboardGrid.state.layout.length', 0) > 0;
    if (needToHydrateDashboardLayout) {
      // we not need to fill position out of range because
      // just needed the positions of current dashboard visible, which are position
      // that came from component that was initialized for us previously in the render method.
      DashboardStore.setInitializedLayoutDashboard();
      DashboardStore.setLayoutWithoutHydrated(get(this.refs, 'dashboardGrid.state.layout', []));
    }

    // ask if we need to recalculate the current visible range of dashboard
    // (only when trigger arrow button to move current visible range of dates)
    if (!DashboardStore.isSavingDraft() && DashboardStore.isTriggerArrow()) {
      visibleLayoutOrders = get(this.refs, 'dashboardGrid.state.layout', []);
      const { from, to } = this.state;
      ChronologycStore.setCurrentRange(from, to);
      DashboardStore.setLayoutWithoutHydrated(visibleLayoutOrders, from, to);
      DashboardStore.unsetTriggerArrow();
      this._fetchOrdersAndDraft(from, to, SessionStore.getCurrentApplicant());
    }

    this._adaptHeightDashboardToNewRangeVisible();

    // just reset flag in case that we trigger before
    DashboardStore.disabledForceRenderDashboard();

    if (this.state.isUserTaskVisible || this.state.isInventoryReportVisible) {
      document.body.classList.add('stop-scroll');
    } else {
      document.body.classList.remove('stop-scroll');
    }

    if (this._someLabelHasChange()) {
      this.setState({
        isVisibleBeerStyleLabelBrewing: SessionStore.isVisibleBeerStyleLabelBrewing(),
        isVisibleBeerStyleLabelFermenting: SessionStore.isVisibleBeerStyleLabelFermenting(),
        isVisibleBeerStyleLabelPackaging: SessionStore.isVisibleBeerStyleLabelPackaging()
      });
    }
  },

  _someLabelHasChange() {
    return this.state.isVisibleBeerStyleLabelBrewing !== SessionStore.isVisibleBeerStyleLabelBrewing() ||
      this.state.isVisibleBeerStyleLabelFermenting !== SessionStore.isVisibleBeerStyleLabelFermenting() ||
      this.state.isVisibleBeerStyleLabelPackaging !== SessionStore.isVisibleBeerStyleLabelPackaging();
  },

  _markOrder(orderId) {
    _markOrders(this.refs.dashboardGrid.getDOMNode(), orderId);
  },

  _shouldRenderDashboard(nextState) {
    if (this.state.immCurrentLayout.count() === 0) {
      // enter here happen on initial rendering of dashboard
      return true;
    }

    if (this.state.isInventoryReportVisible !== get(nextState, 'isInventoryReportVisible')) {
      return true;
    }
    // ask first if we trigger manual render dashboard.
    if (DashboardStore.isNeedForceRenderDashboard()) {
      return true;
      // make a shallow equality in order to know if exist some change
    } else if (nextState && nextState.immCurrentLayout && !Immutable.is(this.state.immCurrentLayout, nextState.immCurrentLayout)) {
      return true;
    }
    return false;
  },

  _setScrollPositionOnToday() {
    this._setPositionScrollByDate(date => DateUtils.isToDay(date), -100);
  },

  _fetchOrdersAndDraft(from, to, applicant) {
    const self = this;
    // retrieve the orders & notes from next dashboard range
    DashboardStore.fetchNextDashboardContent(from, to, applicant, function () {
      const { brewingNotes, packagingNotes, orders, hasDraft } = JSON.parse(this.responseText);
      const orderUpdated = DashboardServiceCache.fillCacheOrder(orders);

      // Indicate that has pending draft operation to publish
      DashboardStore.setHasOperationWithoutPublish(hasDraft);
      ChronologycServiceCache.setBrewingNotes(brewingNotes);
      ChronologycServiceCache.setPackagingNotes(packagingNotes);
      self.setState({ orders: orderUpdated, brewingNotes, packagingNotes });
    });
  },

  _adaptHeightDashboardToNewRangeVisible() {
    if (this.refs.dashboardGrid) {
      const amountDaysCurrentDashboard = DateUtils.getDaysBetween(this.state.from, this.state.to) * 35;
      // change height of dashboard and change position of bottom arrow
      this.refs.dashboardGrid.getDOMNode().style.height = amountDaysCurrentDashboard + 'px';
      if (this.btnBackward) {
        this.btnBackward.getDOMNode().style.top = (amountDaysCurrentDashboard + 140) + 'px';
      }
      if (this.btnForward) {
        const offsetBtnForward = SessionStore.isFullPaidVersion() ? 0 : 50;
        this.btnForward.getDOMNode().style.top = offsetBtnForward + 'px';
      }
    }
  },

  /**
   * Set the position of the scroll in the current month.
   * @private
   */
  _setPositionScrollByDate(conditionFilter, offset, positionAtBottom, onEndScroll) {
    if (!existAtLeastOneTankOnEachSection(this.state.tanks)) {
      // enter here means the dashboard is not loading, so we don't need to position scroll
      return;
    }

    let chronologicMonthEL = this._getChronologycRowByMonthName(conditionFilter);
    let scrollTop;
    if (!positionAtBottom) {
      // TOP
      if (UIStateStore.isBrewingNotesBarOpen() && !UIStateStore.isPackagingNotesBarOpen()) {
        scrollTop = PositionUtils.elementScrollTop(chronologicMonthEL, -1);
      } else if (UIStateStore.isBrewingNotesBarOpen() && UIStateStore.isPackagingNotesBarOpen()) {
        scrollTop = PositionUtils.elementScrollTop(chronologicMonthEL, -1);
      } else {
        scrollTop = PositionUtils.elementScrollTop(chronologicMonthEL, ROW_HIGHT - 1);
      }
    } else {
      // BOTTOM
      if (UIStateStore.isBrewingNotesBarOpen() && !UIStateStore.isPackagingNotesBarOpen()) {
        scrollTop = PositionUtils.elementScrollBottom(chronologicMonthEL, -1 + ROW_HIGHT);
      } else if (UIStateStore.isBrewingNotesBarOpen() && UIStateStore.isPackagingNotesBarOpen()) {
        scrollTop = PositionUtils.elementScrollBottom(chronologicMonthEL, ROW_HIGHT - 6);
      } else {
        scrollTop = PositionUtils.elementScrollBottom(chronologicMonthEL, (ROW_HIGHT - 1) + ROW_HIGHT);
      }
    }
    if (offset !== undefined) {
      scrollTop = offset + scrollTop;
    }
    PositionUtils.scrollTo(scrollTop + (-ROW_HIGHT), null, onEndScroll);
  },

  _getChronologycRowByMonthName(conditionFilter) {
    return filter(this.refs.chronologycBrewingBar.getDOMNode().querySelectorAll('.chronologyc-row.row'), function (row) {
      return conditionFilter(row.getAttribute('data-date'));
    })[0];
  },

  /**
   * Handler invoked each time the store emit incoming changes.
   * @private
   */
  _onChange() {
    const tanksRecover = TankStore.getTanks(),
      orders = OrderStore.getOrders(),
      lastOrderUpdate = OrderStore.getLastOrderUpdate(),
      items = DashboardServiceCache.getItems();

    if (DashboardStore.isNeedCleanSelectedOrders()) {
      DashboardStore.setNeedCleanSelectedOrders(false);
      _clearOrdersSelection(this.getDOMNode());
    }

    this.setState(prevState => {
      return {
        tanks: tanksRecover,
        orders,
        items,
        locationItems: DashboardServiceCache.getLocationItems(),
        vendorPurchaseItems: DashboardServiceCache.getVendorPurchaseItems(),
        lastOrderUpdate,
        draftOrderAmount: (DashboardServiceCache.getOperations() || []).length || DashboardServiceCache.getDraftOrderAmount(),
        undoDraftOrderAmount: DashboardServiceCache.getUndoDraftOrderAmount(),
        isPublishedDisabled: !DashboardStore.hasPendingSavedDraftWithoutPublish(),
        isVisibleBrewingSection: SessionStore.isVisibleBrewingSection(),
        isVisibleFermentingSection: SessionStore.isVisibleFermentingSection(),
        isVisiblePackagingSection: SessionStore.isVisiblePackagingSection(),
        isGuestUser: this._isGuestUserBecauseSomeSectionIsHidden() || prevState.isGuestUser
      };
    });
  },

  _isGuestUserBecauseSomeSectionIsHidden() {
    return [
      SessionStore.isVisibleBrewingSection(),
      SessionStore.isVisibleFermentingSection(),
      SessionStore.isVisiblePackagingSection()
    ].some(isVisibleSection => isVisibleSection === false);
  },

  _onChangeUI() {
    this._fireResize();
  },

  /**
   * Handler event on drag start.
   * @param layout
   * @param position
   * @private
   */
  _onResizeStart(layout, position) {
    initialResizing = new Date().getTime();

    const event = ContentUtils.filterEvents(arguments);
    DashboardStore.setDraggingOrResizing();

    if (event) {
      this._freezeDashboard(layout, position, event);
    }

    visibleLayoutOrders = ContentUtils.clone(layout);
    this.positions.start = ContentUtils.clone(position);
  },

  /**
   * Handler event on resize stop.
   * @param layout
   * @param position
   * @private
   */
  _onResizeStop(layout, position) {
    initialResizing = 0;

    DashboardStore.unsetDraggingOrResizing();

    const event = ContentUtils.filterEvents(arguments);
    const evt = arguments[4];
    evt.preventDefault();
    evt.stopPropagation();

    const backupStop = this.positions.start;
    this.positions.stop = ContentUtils.clone(position);
    this._unFreezeDashboard(layout, position, event);

    const currentOrder = find(this.state.orders, order => get(order, 'id') === ContentUtils.cleanId(position.i));
    if (!SessionStore.isAbleToEditDates()) {
      this.positions.stop = backupStop;
      this._forceRefreshDashboard();
      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
      return;
    }

    if (OrderStore.isResizeAllowed(currentOrder, this.positions)) {
      //this.isStopByPromptConfirm = true;
      delay(() => {
        this._markOrder(position.i, 0);
      }, 500);
      // always render dashboard after resize vertically because we need to check if we move same order in wrong place
      ga.event({
        category: categories.ORDER,
        action: actions.CHANGE,
        label: labels.ORDER_RESIZED + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
      });
    } else {
      this.positions.stop = backupStop;
      this._forceRefreshDashboard();
      Notification.show(t('dashboard_notification_unconfirm_and_publish_before_change'));
    }
  },

  /**
   * Handler event on drag start.
   * @param layout
   * @param position
   * @private
   */
  _onDragStart(layout, position) {
    console.time('Dragging');
    DashboardStore.disabledForceRenderDashboard();
    DashboardStore.setDraggingOrResizing();

    // Filter argument because sometimes when drag from the image, the event argument change the order
    const event = ContentUtils.filterEvents(arguments);
    if (event) {
      this._freezeDashboard(layout, position, event);
    }

    try {
      this.positions.start = ContentUtils.clone(position);
      visibleLayoutOrders = ContentUtils.clone(layout);
    } catch (e) {
      visibleLayoutOrders = layout;
      console.error('On drag start throw error ' + e);
    }
  },

  /**
   * Handler event on drag stop.
   * @param layout
   * @param position
   * @private
   */
  _onDragStop(layout, position) {
    this._unFreezeDashboard(layout, position);
    DashboardStore.unsetDraggingOrResizing();

    window.scroll(0, window.scrollY); // Fix in case that drag outside of current viewport

    this.positions.stop = ContentUtils.clone(position);

    const isSamePosition = ContentUtils.isSameObject(this.positions.start, this.positions.stop, ['x', 'y', 'h']);
    if (!SessionStore.isAbleToEditDates()) {
      this._forceRefreshDashboard();
      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
      return;
    }
    if (isSamePosition) {
      // enter here means the user just clicked above an order.
      // so the only needed is to hightlighet the order
      //this._markOrder(position.i, 0);
    } else {
      delay(() => {
        this._markOrder(position.i, 0);
        ga.event({
          category: categories.ORDER,
          action: actions.CHANGE,
          label: labels.ORDER_DRAG_AND_DROP + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
        });
      }, 50);
    }
  },

  _forceRefreshDashboard() {
    this._cleanPositions();
    AppDispatcher.dispatch({ type: ActionTypes.FORCE_MANUAL_DRAWING_DASHBOARD });
    const self = this;
    setTimeout(() => {
      self._fireResize();
      self.forceUpdate();
    }, 100);
  },

  _freezeDashboard(layout, position) {
    if (!isDashboardAlreadyFreezed) {
      isDashboardAlreadyFreezed = true;
      forEach(layout, (l) => {
        // To avoid freeze orders in non-dragging ca_onSingleClickses.
        if (l.i !== position.i) {
          l.static = true;
        }
      });
    }
  },

  _unFreezeDashboard(layout, position) {
    forEach(layout, (l) => {
      // for that always are static.
      if (l.i !== position.i) {
        l.static = false;
      }
    });
    isDashboardAlreadyFreezed = false;
  },

  /**
   * Fire resize event in order to repaint dashboard.
   * @private
   */
  _fireResize() {
    const evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    delay(() => {
      window.dispatchEvent(evt);
    }, 250);
  },

  /**
   * Execute publish current draft.
   * @param evt
   * @private
   */
  _onPublishDraft(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    DashboardActionCreators.publishingDraft();
  },

  _onToggleCalculateInventory(evt) {
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      evt.preventDefault();
    } 
    this.setState(prevState => {
      return { 
        isCalculatingInventory: !prevState.isCalculatingInventory
      };
    }, () => {
      this._forceRefreshDashboard();
      SessionStore.setIsCalculatingInventory(this.state.isCalculatingInventory);
    });
  },

  /**
   * On change of the grid layout component.
   */
  _onLayoutChange() {
    if (this._needRenderDashboard()) {
      try {
        DashboardStore.setLayoutWithoutHydrated(visibleLayoutOrders);
        const newOrder = OrderStore.moveOrders(this.positions.start, this.positions.stop);
        // get from view the current update layout
        visibleLayoutOrders = get(this.refs, 'dashboardGrid.state.layout') || visibleLayoutOrders;

        if (!newOrder) {
          DashboardActionCreators.forceRenderDashboard();
          return;
        }

        DashboardCache.removeOrderAndCleanCacheScopeInventory(get(newOrder, 'id'));
        this.setState({
          immCurrentLayout: Immutable.fromJS(visibleLayoutOrders),
          isPublishedDisabled: !DashboardStore.hasPendingSavedDraftWithoutPublish()
        });
      } catch (e) {
        console.error(e.message);
      } finally {
        this._cleanPositions();
        console.timeEnd('Dragging');
      }
    }
  },

  /**
   * clean current positions.
   * @private
   */
  _cleanPositions() {
    this.positions.stop = null;
    this.positions.start = null;
  },

  /**
   * Validate if is necessary trigger render dashboard or not.
   * @return {boolean}
   * @private
   */
  _needRenderDashboard() {

    if (ContentUtils.isNull(this.positions) || ContentUtils.isNull(this.positions.start) || ContentUtils.isNull(this.positions.stop)) {
      return false;
    }

    if (DashboardStore.isNeedForceRenderDashboard() && !DashboardStore.isSavingDraft() && !DashboardStore.isTriggerArrow()) {
      DashboardStore.disabledForceRenderDashboard();
      return true;
    }

    if (this.state.shouldRenderDashboard) {
      this.state.shouldRenderDashboard = false;
      return true;
    }

    if (this.positions.start && this.positions.stop && !this.isStopByPromptConfirm) {
      if (!ContentUtils.isSameObject(this.positions.start, this.positions.stop, propsToValiadte)) {
        return true;
      }
    }

    return false;
  },

  _getChronologycElByClientY(elY) {
    // enter here means that we clicked an empty cell with brewing note closed, so the element which found was the span of chronologyc
    return ContentUtils.getComponentByAttribute(elY, 'data-date');
  },

  _forwardOrder() {
    if (DashboardStore.isSavingDraft()) {
      // enter here means the scroll could not be load until finish
      // to save draft
      return false;
    }
    PositionUtils.enableScrolling();
    DashboardActionCreators.hideLoading();
    const dates = DateUtils.incrementByDays(
      this.state.dateReference,
      this.state.from,
      this.state.to,
      -DAYS_BACKWARD_FORWARD);

    const lastFrom = this.state.from;

    DashboardStore.forceRenderDashboard();
    DashboardStore.setTriggerArrow();

    // fix issue when focus are in some notes, after
    // autos-scrolling don't re-locate the note
    this._resetFocus();

    // need to reset because the transition order
    // when select is not looking good here
    _clearOrdersSelection(this.getDOMNode());

    this.setState(prevState => {
      return {
        from: dates.from,
        to: dates.to,
        dateReference: dates.date,
        isDashboardBackwardForwarePristine: false,
        isPublishedDisabled: !DashboardStore.hasPendingSavedDraftWithoutPublish()
      };
    }, () => {
      this._setPositionScrollByDate(function (date) {
        return date === lastFrom;
      }, 0, false, () => {
        // On end scroll.
      });
    });
    if (this.refs.chronologycBrewingBar && this.refs.chronologycPackagingBar) {
      // Fix issue that not execute render in chronology bar
      this.refs.chronologycBrewingBar.forceUpdate();
      this.refs.chronologycPackagingBar.forceUpdate();
    }
  },

  _backwardOrder() {
    if (DashboardStore.isSavingDraft()) {
      // enter here means the scroll could not be load until finish
      // to save draft
      return false;
    }
    PositionUtils.enableScrolling();
    DashboardActionCreators.hideLoading();
    const dates = DateUtils.incrementByDays(
      this.state.dateReference,
      this.state.from,
      this.state.to,
      DAYS_BACKWARD_FORWARD);

    const lastTo = this.state.to;
    DashboardStore.forceRenderDashboard();
    DashboardStore.setTriggerArrow();

    // fix issue when focus are in some notes, after
    // autos-scrolling don't re-locate the note
    this._resetFocus();

    // need to reset because the transition order
    // when select is not looking good here
    _clearOrdersSelection(this.getDOMNode());

    this.setState(() => {
      return {
        from: dates.from,
        to: dates.to,
        dateReference: dates.date,
        isDashboardBackwardForwarePristine: false,
        isPublishedDisabled: !DashboardStore.hasPendingSavedDraftWithoutPublish()
      };
    }, () => {
      this._setPositionScrollByDate(function (date) {
        return date === lastTo;
      }, 0, true, () => {
        // On end scrolling
      });
    });

    if (this.refs.chronologycBrewingBar && this.refs.chronologycPackagingBar) {
      // Fix issue that not execute render in chronology bar
      this.refs.chronologycBrewingBar.forceUpdate();
      this.refs.chronologycPackagingBar.forceUpdate();
    }
  },

  _resetFocus() {
    if (document && document.activeElement) {
      document.activeElement.blur();
    }
  },

  _onRightClick(evt) {
    evt.preventDefault();
    const tankType = evt.target.getAttribute('data-tank-type');
    const orderId = evt.target.getAttribute('data-order-id');
    const currentDashboard = this.refs.dashboardGrid.state.layout;

    if (orderId) {
      AppDispatcher.dispatch({
        type: ActionTypes.RIGHT_DOUBLE_CLICK_DASHBOARD_OCCUPIED,
        orderId: evt.target.getAttribute('data-order-id'),
        positionX: evt.clientX,
        positionY: evt.clientY,
        dateClicked: ChronologycStore.getDateFromClientY(evt.clientY),
        tankClicked: DashboardStore.getTankFromClientX(evt.clientX),
        isFermenterTank: tankType === 'FV',
        batchNumber: get(OrderStore.getOrder(orderId), 'batchNumber'),
        tankType,
        currentDashboard
      });
    } else {
      AppDispatcher.dispatch({
        type: ActionTypes.RIGHT_CLICK_DASHBOARD,
        positionX: evt.clientX,
        positionY: evt.clientY,
        dateClicked: ChronologycStore.getDateFromClientY(evt.clientY),
        tankClicked: DashboardStore.getTankFromClientX(evt.clientX),
        isFermenterTank: tankType === 'FV',
        tankType,
        currentDashboard
      });
    }
  },

  _onSingleClick(evt) {

    if (window.Cypress) {
      const clientY = window.Cypress.env('fixture.orderClickedY');
      const clientX = window.Cypress.env('fixture.orderClickedX');
      this._onDoubleClickEmptyCell(Object.assign({}, evt,
        {
          clientY,
          clientX,
          preventDefault: () => {
          },
          stopPropagation: () => {
          }
        }));
      return;
    }

    if (evt && evt.target) {
      evt.preventDefault();
      evt.stopPropagation();
      const newOrderSelectedId = evt.target.getAttribute('data-order-id');
      const newOrderSelected = OrderStore.getOrder(newOrderSelectedId);
      if (newOrderSelected) {
        OrderStore.updateLastOrderUpdated(newOrderSelected);
      }
      this._markOrder(newOrderSelectedId);
        if (newOrderSelectedId != null) {
            //Notification.show('Icon/s confirmed, unconfirm to make changes');
        } else {
            this._onDoubleClickEmptyCell(evt);
        }
    }
  },

  /**
   * Capture element from cords of mouse click on empty cell of dashboard.
   * @param {MouseEvent} evt
   * @private
   */
  _onDoubleClickEmptyCell(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const tankClicked = DashboardStore.getTankFromClientX(evt.clientX);

    _clearOrderSelected(evt.target);

    if (tankClicked) {
      const dateClicked = ChronologycStore.getDateFromClientY(evt.clientY);
      const preDefinedOrder = {
        date: dateClicked,
        tankSelected: tankClicked,
        tankType: get(tankClicked, 'type')
      };

      if (!SessionStore.isAbleToEditDates()) {
        Notification.show(t('dashboard_notification_dont_enough_permission_section'));
        return;
      }

      this._prepareDashboardToNewOrder();

      AppDispatcher.dispatch({
        type: ActionTypes.LEFT_DOUBLE_CLICK_DASHBOARD_EMPTY,
        preDefinedOrder
      });
    }
  },

  /**
   * Open a Modal order.
   * @private
   */
  _prepareDashboardToNewOrder() {
    _clearOrderSelected(this.refs.dashboardGrid.getDOMNode());
    ga.modalview('/dashboard/new-order-from-empty-cell');
  },

  _registerScrollWatcher() {
    this.intervalCheckScrollWatcher = setInterval(this._checkIfNeedMoreContent, 500);
  },

  _checkIfNeedMoreContent() {
    const isScrollOnTop = Viewport.isInsideViewport(document.querySelector('.btn-center-top-fixed'));
    const isScrollOnBottom = Viewport.isInsideViewport(document.querySelector('.btn-center-bottom-fixed'));

    if (scrollingAdjustInProgress) {
      // enter here means is in progress scrolling movement
      return;
    }
    if (isScrollOnTop) {
      DashboardActionCreators.showLoading();
      scrollingAdjustInProgress = true;
      PositionUtils.disableScrolling();
      delay(() => {
        scrollingAdjustInProgress = false;
        const isScrollOnTop = Viewport.isInsideViewport(document.querySelector('.btn-center-top-fixed'));
        if (isScrollOnTop) {
          document.querySelector('.btn-center-top-fixed').click();
        }
      }, 800);
    } else if (isScrollOnBottom) {
      DashboardActionCreators.showLoading();
      scrollingAdjustInProgress = true;
      PositionUtils.disableScrolling();
      delay(() => {
        scrollingAdjustInProgress = false;
        const isScrollOnBottom = Viewport.isInsideViewport(document.querySelector('.btn-center-bottom-fixed'));
        if (isScrollOnBottom) {
          document.querySelector('.btn-center-bottom-fixed').click();
        }
      }, 800);
    }
  },

  getFixedFreeVersionAdvertisement() {
    return (
      React.createElement("div", {className: "free-version-advertisement"}, 
        React.createElement("p", null, t('dashboard_notification_free_trial_platium_version')), 
        React.createElement(FlatButton, {
          label: t('dashboard_label_try_now'), 
          primary: true, 
          onTouchTap: onClickTryProVersion.bind(this)
        }
        )
      )
    );
  },

  _onClickUndo(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    DashboardActionCreators.undoDraft();
  },

  _onClickRedoButton(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    DashboardActionCreators.redoDraft();
  },

  _handlerOpenUserTask(date, isToggle) {
    if (UserTaskStore.isAllChangesSaved()) {
      this.setState(prevState => ({
        isUserTaskVisible: isToggle ? !prevState.isUserTaskVisible : true,
        userTaskDate: DateUtils.toDateText(date ? date : prevState.userTaskDate)
      }), () => {
        if (this.state.isUserTaskVisible) {
          DashboardActionCreators.fetchScheduleBoardByDate(DateUtils.toDateText(date));
        }
      });
    } else {
      CustomDialog.showWarningConfirmation(t('warning'), t('dashboard_user_task_notification_please_save_changes'), () => {
        UserTaskStore.resetAllChangesNote();
        this.setState(prevState => ({
          isUserTaskVisible: isToggle ? !prevState.isUserTaskVisible : true,
          userTaskDate: DateUtils.toDateText(date ? date : prevState.userTaskDate)
        }), () => {
          if (this.state.isUserTaskVisible) {
            DashboardActionCreators.fetchScheduleBoardByDate(DateUtils.toDateText(date));
          }
        });
      });
    }
  },

  _timeouts: [],

  _handlerToggleOpenUserTask(date) {
    const isToggle = true;
    this.toggleTasks(() => {
      this._handlerOpenUserTask(date, isToggle);
    });
  },

  _handlerKeepOpenUserTask(date) {
    this.openTasks(() => {
      this._handlerOpenUserTask(date);
    });
  },

  clearTimeout() {
    if (this._timeouts && this._timeouts.length) {
      this._timeouts.forEach(time => clearTimeout(time));
    }
  },

  _handlerToggleUserTask() {
    this.toggleTasks(() => {
      this.setState(prevState => ({
        isUserTaskVisible: !prevState.isUserTaskVisible,
        userTaskDate: DateUtils.toDateText(prevState.userTaskDate
          ? prevState.userTaskDate
          : DateUtils.getCurrentDate())
      }), () => {
        if (this.state.isUserTaskVisible) {
          DashboardActionCreators.fetchScheduleBoardByDate(DateUtils.toDateText(this.state.userTaskDate))
        }
      });
    });
  },

  closeTasks(onClose) {
    document.querySelector('.tasks').classList.add('is-hidden');
    this._timeouts.push(setTimeout(() => {
      onClose();
      this.clearTimeout();
    }, 501));
  },

  toggleTasks(onToggle) {
    document.querySelector('.tasks').classList.toggle('is-hidden');
    this._timeouts.push(setTimeout(() => {
      onToggle();
      this.clearTimeout();
    }, 501));
  },

  openTasks(onOpen) {
    const taskEl = document.querySelector('.tasks');
    if (taskEl.classList.contains('is-hidden')) {
      taskEl.classList.remove('is-hidden');
      this._timeouts.push(setTimeout(() => {
        onOpen();
        this.clearTimeout();
      }, 501));
    } else {
      onOpen();
    }
  },

  render() {
    let dashboardBody = ' dashboard-body',
      dashboardHeader = ' dashboard-header';

    dashboardHeader = UIStateStore.isBrewingNotesBarOpen() ? 'is-brewing-note-open' : 'is-brewing-note-close';
    dashboardHeader = UIStateStore.isPackagingNotesBarOpen() ? dashboardHeader + ' is-packaging-note-open' : (dashboardHeader + ' is-packaging-note-close');

    dashboardBody = this.state.isDashboardBackwardForwarePristine ? dashboardHeader + ' is-pristine' : dashboardHeader;
    dashboardBody = !UIStateStore.isPackagingNotesBarOpen() ? dashboardHeader + ' is-packaging-note-collapsed' : dashboardHeader;
    dashboardBody = !UIStateStore.isBrewingNotesBarOpen() ? dashboardHeader + ' is-brewing-note-collapsed' : dashboardHeader;
    const amountDaysCurrentDashboard = DateUtils.getDaysBetween(this.state.from, this.state.to);

    if (this.state.tanks === undefined || this.state.tanks.length === 0) {
      return (
        (React.createElement(Loading, null))
      );
    }

    if (!existAtLeastOneTankOnEachSection(this.state.tanks)) {
      return ShowNotificationShouldExistOneTankPerSection();
    }

    const {
      tanks,
      orders,
      from,
      to,
      isDashboardBackwardForwarePristine,
      isSearchExpand,
      draftOrderAmount,
      undoDraftOrderAmount,
      isUserTaskVisible,
      isInventoryReportVisible,
      userTaskDate,
      items,
      locationItems,
      vendorPurchaseItems,
      isFilterModeActivated,
      filterItem,
      isVisibleBrewingSection,
      isVisibleFermentingSection,
      isVisiblePackagingSection,
      isGuestUser
    } = this.state;

    const enableTanks = ContentUtils.filterDisableTankDisabledIfNotHaveOrder(tanks, orders);
    const tanksFilteredBySection = ContentUtils.filterTanksBySections(enableTanks, {
      isVisibleBrewingSection,
      isVisibleFermentingSection,
      isVisiblePackagingSection
    });
    const isSaving = DashboardStore.isSavingDraft();
    const tanksEl = drawHeaderTanksEl(tanksFilteredBySection, {
      isVisibleBrewingSection,
      isVisibleFermentingSection,
      isVisiblePackagingSection
    });
    const ordersEl = drawOrdersEl(this);

    const isPublishButtonVisible = isPublishButtonReadyToPublish() || (draftOrderAmount > 0 || undoDraftOrderAmount > 0);
    const publishDraftButton = (
      React.createElement(FloatingActionButton, {
        ref: "btnPublish", 
        style: { 'display': isPublishButtonVisible ? 'inherit' : 'none'}, 
        onClick: this._onPublishDraft, className: "with-opacity btn-right-fixed btn-right-upload hidden-xs", 
        iconClassName: "with-opacity muidocs-icon-action-grade", backgroundColor: "#0f9d58"}, 
        React.createElement("i", {className: "material-icons md-48 btn-icon-center"}, "cloud_upload")
      )
    );

    const {
      undoButton,
      redoButton,
      forwardButton,
      backwardButton,
      iconUserTask,
      iconInventoryReport
    } = getDashboardButtons.call(
      this,
      isPublishButtonVisible,
      draftOrderAmount,
      isSaving,
      undoDraftOrderAmount,
      isDashboardBackwardForwarePristine,
      this._handlerToggleUserTask
    );

    const iconDisableShowInventory = React.createElement("i", {className: "material-icons md-48 btn-icon-center"}, "calculate");
    const iconDisableShowInventoryEl = SessionStore.isFullPaidVersion() ? getToggleShowInventoryButtonEl.call(this, isPublishButtonVisible, isSearchExpand, iconDisableShowInventory) : null;

    const shouldShowGuestIndicator = isGuestUser ? true : !SessionStore.isAdminUser();
    const isAllSectionActive = isVisibleBrewingSection && isVisibleFermentingSection && isVisiblePackagingSection;

    const readOnlyIndicator = shouldShowGuestIndicator ? (
      React.createElement(DashboardViewOnlyIndicator, {isAllSectionActive: isAllSectionActive})
    ) : null;

    const customOverlayEl = (
      React.createElement(CustomOverlay, {isVisible: DashboardStore.isPublishingDraft(), 
        text: t('dashboard_text_publishing_in_progress')})
    );

    const customOverlayFilterEl = (
      React.createElement(CustomOverlay, {isVisible: isSearchExpand || isFilterModeActivated})
    );

    const dashboardBodyClassName = 'dashboard-body' + (SessionStore.isPaidVersion() ? '' : ' is-free-version');
    let dashboardPageClassName = 'dashboard-content' + (SessionStore.isPaidVersion() ? '' : ' is-free-version');

    if (UIStateStore.isBrewingNotesBarOpen()) {
      dashboardPageClassName += ' is-parent-brewing-note-open';
    } else {
      dashboardPageClassName += ' is-parent-brewing-note-close';
    }

    if (UIStateStore.isPackagingNotesBarOpen()) {
      dashboardPageClassName += ' is-parent-packaging-note-open';
    } else {
      dashboardPageClassName += ' is-parent-packaging-note-close';
    }

    return (
      React.createElement("section", {id: "dashboard-id", className: dashboardPageClassName}, 
        customOverlayEl, 
        customOverlayFilterEl, 
        readOnlyIndicator, 
        React.createElement(ChronologycBar, {
          showForwardOrders: this._forwardOrder, 
          showBackwardOrders: this._backwardOrder, 
          ref: "chronologycBrewingBar", shouldUpdate: true, typeBar: "brewing-bar", 
          from: from, 
          to: to, 
          onDoubleClick: this._handlerKeepOpenUserTask}
        ), 
        React.createElement(ChronologycBar, {ref: "chronologycPackagingBar", shouldUpdate: true, typeBar: "packaging-bar", 
          from: from, 
          to: to, 
          onDoubleClick: this._handlerKeepOpenUserTask}
        ), 
        React.createElement("div", {className: "dashboard-header"}, 
          React.createElement(ReactGridLayout, {
            ref: "dashboardHeaderGrid", 
            className: dashboardHeader, 
            initialWidth: "1280", 
            cols: tanksFilteredBySection.length, 
            rowHeight: ROW_HIGHT, 
            margin: [1, 1], 
            verticalCompact: false, 
            autoSize: false, 
            useCSSTransforms: true, 
            isResizable: true, 
            breakpoints: BREAK_POINTS_DASHBOARD}, 
            tanksEl
          )
        ), 
        React.createElement("div", {className: dashboardBodyClassName, "data-days-current-range": amountDaysCurrentDashboard}, 
          React.createElement(ReactGridLayout, {
            ref: "dashboardGrid", 
            className: dashboardBody, 
            initialWidth: "1280", 
            cols: tanksFilteredBySection.length, 
            rowHeight: ROW_HIGHT, 
            margin: [1, 1], 
            onDragStop: this._onDragStop, 
            onDragStart: this._onDragStart, 
            onResizeStart: this._onResizeStart, 
            onResizeStop: this._onResizeStop, 
            onLayoutChange: this._onLayoutChange, 
            onDoubleClick: this._onDoubleClickEmptyCell, 
            onClick: this._onSingleClick, 
            onContextMenu: this._onRightClick, 
            verticalCompact: false, 
            autoSize: false, 
            useCSSTransforms: true, 
            isResizable: true, 
            breakpoints: BREAK_POINTS_DASHBOARD
          }, 
            ordersEl
          )
        ), 

        iconInventoryReport, 

        iconUserTask, 

        iconDisableShowInventoryEl, 

        publishDraftButton, 

        redoButton, 

        undoButton, 

        forwardButton, 

        backwardButton, 

        React.createElement(UserTasks, {
          date: userTaskDate, 
          isUserTaskVisible: isUserTaskVisible, 
          onClickClose: () => {
            this.closeTasks(() => this.setState({ isUserTaskVisible: false }));
          }, 
          onChangeDate: this._handlerOpenUserTask}
        ), 

        React.createElement(InventoryReport, {
          items: items, 
          dateFrom: from, 
          dateTo: to, 
          locationItems: locationItems, 
          vendorPurchaseItems: vendorPurchaseItems, 
          isVisible: isInventoryReportVisible, 
          orders: this.state.orders, 
          itemSelected: filterItem, 
          onSelectItem: (item) => {
            this.setState(prevState => {
              return {
                filterItem: item,
                isFilterModeActivated: !!item,
                filterToggleChange: !prevState.filterToggleChange
              };
            }, () => this.forceUpdate());
          }, 
          onClose: () => this.setState({
            isInventoryReportVisible: false,
            isFilterModeActivated: false,
            filterItem: null
          })}
        )

      )
    );
  }
});

function getDashboardButtons(isPublishButtonVisible, draftOrderAmount, isSaving, undoDraftOrderAmount, isDashboardBackwardForwarePristine, handlerOpenUserTask) {
  const undoButton = (
    React.createElement(FloatingActionButton, {
      ref: "btnUndo", 
      style: { 'display': isPublishButtonVisible && draftOrderAmount > 0 && !isSaving ? 'inherit' : 'none'}, 
      onClick: this._onClickUndo, 
      className: `btn-undo-redo btn-undo ${(+undoDraftOrderAmount) > 0 ? ' with-redo' : ''} with-opacity hidden-xs`, 
      iconClassName: "muidocs-icon-action-grade", backgroundColor: "#B3B3B3"}, 
      React.createElement("i", {className: "material-icons md-48 btn-icon-center"}, "undo")
    )
  );
  const redoButton = (
    React.createElement(FloatingActionButton, {
      ref: "btnRedo", 
      style: { 'display': isPublishButtonVisible && (+undoDraftOrderAmount) && !isSaving > 0 ? 'inherit' : 'none'}, 
      onClick: this._onClickRedoButton, 
      className: `btn-undo-redo btn-redo ${(+undoDraftOrderAmount) > 0 ? ' with-redo' : ''} with-opacity hidden-xs`, 
      iconClassName: "muidocs-icon-action-grade", backgroundColor: "#B3B3B3"}, 
      React.createElement("i", {className: "material-icons md-48 btn-icon-center"}, "redo")
    )
  );

  const forwardButton = (
    React.createElement(FloatingActionButton, {
      backgroundColor: "#fff", 
      ref: el => {
        if (el) {
          this.btnForward = el;
        }
      }, 
      onClick: this._forwardOrder, className: "btn-center-top-fixed btn-backward-order", 
      iconClassName: "muidocs-icon-action-grade"}, 
      React.createElement("i", {className: "material-icons md-48 btn-icon-center"})
    )
  );

  const backwardButton = (
    React.createElement(FloatingActionButton, {
      backgroundColor: "#fff", 
      ref: el => {
        if (el) {
          this.btnBackward = el;
        }
      }, 
      onClick: this._backwardOrder, 
      className: isDashboardBackwardForwarePristine ? 'btn-center-bottom-fixed btn-forware-order is-pristine' : 'btn-center-bottom-fixed btn-forware-order', 
      iconClassName: "muidocs-icon-action-grade"}, 
      React.createElement("i", {className: "material-icons md-48 btn-icon-center"})
    )
  );

  const iconUserTask = (
    React.createElement("div", {className: `btn-user-tasks with-opacity${isPublishButtonVisible ? ' is-button-draft-visible' : ''}`}, 
      React.createElement(FloatingActionButton, {
        onClick: () => {
          UserTaskStore.resetAllChangesNote();
          handlerOpenUserTask(DateUtils.getCurrentDate());
        }, 
        style: { color: '#fff !important'}, 
        iconClassName: "muidocs-icon-action-grade", 
        backgroundColor: this.state.isUserTaskVisible ? '#0f9d58' : '#B3B3B3'
      }, 
        React.createElement("i", {className: "material-icons md-48 btn-icon-center"}, "checklist")
      )
    )
  );

  const iconInventoryReport = (
    React.createElement("div", {
      className: `btn-user-tasks btn-inventory-report with-opacity${isPublishButtonVisible ? ' is-button-draft-visible' : ''}`}, 
      React.createElement(FloatingActionButton, {
        onClick: () => {
          this.setState(prevState => {
            return {
              isInventoryReportVisible: !prevState.isInventoryReportVisible
            };
          });
        }, 
        style: { color: '#fff !important'}, 
        iconClassName: "muidocs-icon-action-grade", 
        backgroundColor: this.state.isInventoryReportVisible ? '#0f9d58' : '#B3B3B3'
      }, 
        React.createElement("i", {className: "material-icons md-48 btn-icon-center"}, "list")
      )
    )
  );

  return {
    undoButton,
    redoButton,
    forwardButton,
    backwardButton,
    iconUserTask,
    iconInventoryReport
  };
}

function existAtLeastOneTankOnEachSection(tanks) {
  const existBHTank = some(tanks, t => t.type === 'BH');
  const existFVTank = some(tanks, t => t.type === 'FV');
  const existBTTank = some(tanks, t => t.type === 'BT');
  return existBHTank && existFVTank && existBTTank;
}

/**
 * Retrieve the elements Header, such as fermenters and carbonators, that will
 * fill the Header section of the Dashboard.
 *
 * @argument {Array} tanks the list of fermenter & carbonators.
 * @argument {Array} orders from the dashboard
 * @return {Array} return the Fermenter & Carbonators Header elements.
 */
function drawHeaderTanksEl(tanks, {
  isVisibleBrewingSection,
  isVisibleFermentingSection,
  isVisiblePackagingSection
}) {
  let elements = [],
    sizeRow = 1,
    isFistBriteTankFounded = false,
    isFistFermenterTankFounded = false,
    tankClassName = 'fixed-header';

  const isDisableBrewSeparator = !isVisibleBrewingSection && !isVisibleFermentingSection && isVisiblePackagingSection ||
    !isVisibleBrewingSection && isVisibleFermentingSection && !isVisiblePackagingSection ||
    !isVisibleBrewingSection && isVisibleFermentingSection && isVisiblePackagingSection;

  if (isDisableBrewSeparator) {
    tankClassName += ' is-disable-brew-separator';
  }

  ContentUtils.filterEnable(tanks).forEach(function (tank, index, array) {
    const item = array[index + 1] || { type: '' };
    if (!isFistFermenterTankFounded && array.length > 1 && item.type === 'FV') {
      tankClassName += ' is-first-fermenter';
      isFistFermenterTankFounded = true;
    } else if (!isFistBriteTankFounded && array.length > 1 && item.type === 'BT') {
      tankClassName += ' is-first-britetank';
      isFistBriteTankFounded = true;
    } else {
      tankClassName = 'fixed-header';
    }

    if (!SessionStore.isPaidVersion()) {
      tankClassName += ' is-free-version';
    }

    elements.push(React.createElement("div", {className: tankClassName, 
      "data-tank-type": tank.type, 
      "data-tank-id": tank.id, 
      "data-tank-is-enable": tank.enable, 
      "data-tank-volume": tank.volume + tank.unit, 
      ref: tank.id, 
      key: tank.id, 
      _grid: {
        x: index,
        y: 0,
        w: 1,
        h: sizeRow,
        static: true
      }}, 
      React.createElement("span", {
        "data-tank-type": tank.type, 
        "data-tank-id": tank.id, 
        "data-tank-is-enable": tank.enable, 
        "data-tank-volume": tank.volume + tank.unit, 
        className: "fixed-header-tank-name"}, tank.name)
    ));
  });

  return elements;
}

/**
 * We need to be sure, that all draft operation are already saved in order to be ready to publish.
 * Otherwise we could left some latest changes for some order outside of the publishing mechanism.
 * @returns {boolean}
 */
function isPublishButtonReadyToPublish() {
  return SessionStore.isAdminUser()
    && DashboardStore.hasOperationWithoutPublish()
    && DashboardServiceCache.isAllOperationAlreadySaved();
}

/**
 * Draw the visible orders of the Dashboard.
 * @param context
 * @return {Array} Orders elements.
 */
function drawOrdersEl(context) {
  const state = context.state;
  let orderEl;
  let ordersEl = [];
  let batchsEl;
  const hydratedOrders = InventoryStore.hydrateOrderTaskWithInventoryScopeEstimation(state.orders);
  if (hydratedOrders) {
    forEach(ContentUtils.filterEnable(hydratedOrders), order => {
      orderEl = undefined;
      if (ContentUtils.isEmptyArray(orderEl)) {
        if (order && order.isSingle) {
          orderEl = drawSingleOrder(order, state.from, state.to, context);
          if (orderEl) {
            DashboardCache.addOrderEl(state.from, state.to, order.id, orderEl);
            ordersEl = union(ordersEl, orderEl);
          }
        } else {
          if ((DateUtils.isBefore(order.orderDate, state.from)) || (DateUtils.isAfter(order.brewDate, state.to))) {
            //console.warn('WARNING: your are getting orders out of range of current range of dashbord');
          } else {
            orderEl = drawOrderEl(order, state.from, state.to, context);
            if (orderEl) {
              DashboardCache.addOrderEl(state.from, state.to, order.id, orderEl);
              ordersEl = union(ordersEl, orderEl);
            }
          }
        }
      } else {
        ordersEl = union(ordersEl, orderEl);
      }

      batchsEl = undefined;
      if (ContentUtils.isEmptyArray(batchsEl)) {
        batchsEl = drawBrewhouseBatchs(state, order, context);
        if (ContentUtils.isNotEmptyArray(batchsEl)) {
          DashboardCache.addBatchEl(state.from, state.to, order.id, batchsEl);
          ordersEl = union(ordersEl, batchsEl);
        }
      } else {
        ordersEl = union(ordersEl, batchsEl);
      }
    });

    return ordersEl;
  }
}

/**
 * Create an UI elments of the order
 * @argument order {Object} the order that we take all information about it.
 * @argument from {String} the date from
 * @argument to {String} the date to
 */
function drawOrderEl(order, from, to, context) {
  const isSomeProductConfirmed = OrderUtils.haveSomeProductConfirmed(OrderUtils.getTaskFromOrder(order));
  const isOrderPartiallyOutSideOfDashboardRange = !OrderUtils.isOrderInRange(from, to, order);
  const isOrderStatic = context.state.isGuestUser
    ? true
    : isOrderPartiallyOutSideOfDashboardRange
      ? true
      : !context.state.isAbleToEditDates;

  const isVisibleBeerStyleLabelFermenting = context.state.isVisibleBeerStyleLabelFermenting;
  const isVisibleBeerStyleLabelPackaging = context.state.isVisibleBeerStyleLabelPackaging;
  const isClosedOrder = get(order, 'closed') === true;

  if (!order.fermenterTank || !order.briteTank) {
    //console.warn('***** ORDER TANK NULL:' + JSON.stringify(order));
    return null;
  }

  if (!order.styleBeer) {
    //console.warn('***** ORDER STYLE_BEER NULL:' + JSON.stringify(order));
    return null;
  }

  let elements = [];

  const fermenterHY = _calculateHY(from, to, order.brewDate, order.filtrationDate),
    orderHY = _calculateHY(from, to, order.filtrationDate, order.orderDate);

  const isCurrentLastOrderChanged = ContentUtils.cleanId(order.id) === ContentUtils.cleanId(get(OrderStore.getLastOrderUpdate(), 'id'));

  if (!fermenterHY && !orderHY) {
    return elements;
  }

  const itemFiltered = get(context, 'state.filterItem');
  const maxScopeInventoryDate = get(context, 'state.maxScopeInventoryDate');
  const isCalculatingInventory = get(context, 'state.isCalculatingInventory');
  const minDateInventory = get(context, 'state.minDateInventory');

  // Fermenter tasks
  const fermenterTasks = filter(order.fermenterTasks, task => DateUtils.isAfterOrEquals(task.date, from) && DateUtils.isBeforeOrEquals(task.date, to));
  const fermenterTasksSorted = DateUtils.sortListByDateField(fermenterTasks, 'date');
  const fermenterTasksEl = map(fermenterTasksSorted, task =>
    drawIconAndLabel(
      order,
      task,
      from,
      'FV',
      itemFiltered,
      maxScopeInventoryDate,
      isCalculatingInventory,
      minDateInventory
    ));
  const isSearchExpand = get(context, 'state.isSearchExpand') || get(context, 'state.isFilterModeActivated');
  const fermenterIsHighLighted = isSearchExpand ? InventoryStore.isSomeItemInTasks(fermenterTasks, itemFiltered) : false;

  // Packaging tasks
  const packagingTasks = filter(order.packagingTasks, taskFilter => DateUtils.isAfterOrEquals(taskFilter.date, from) && DateUtils.isBeforeOrEquals(taskFilter.date, to));
  const packagingTasksSorted = DateUtils.sortListByDateField(packagingTasks, 'date');
  const packagingTasksEl = map(packagingTasksSorted, task =>
    drawIconAndLabel(
      order,
      task,
      from,
      'BT',
      itemFiltered,
      maxScopeInventoryDate,
      isCalculatingInventory,
      minDateInventory
    ));
  const packagingTasksIsHighLighted = isSearchExpand ? InventoryStore.isSomeItemInTasks(packagingTasks, itemFiltered) : false;

  const isOrderSelected = order.id === get(OrderStore.getLastOrderUpdate(), 'id');
  let className = isCurrentLastOrderChanged ? 'is-fermenter order-style is-last-order-changed' : 'is-fermenter order-style';
  let classNameBT = isCurrentLastOrderChanged ? 'order-style is-last-order-changed' : 'order-style';

  if (isOrderPartiallyOutSideOfDashboardRange) {
    className += ' is-partially-out-side-of-dashboard';
  }

  if (fermenterHY && context.state.isVisibleFermentingSection) {
    const xPosition = +order.fermenterTank.column;
    elements.push(
      React.createElement("div", {
        onDoubleClick: onDoubleClickOrder, 
        onTouchTap: BrowserUtils.isIpad() ? onDoubleClickOrder : null, 
        onContextMenuCapture: openRightButtonContextMenu, 
        className: className + (fermenterIsHighLighted ? ' is-filter-active' : ''), 
        "data-tank-type": 'FV', 
        "data-x": xPosition, 
        "data-y": fermenterHY.y, 
        "data-first-date": "", 
        "data-some-product-confirmed": isSomeProductConfirmed, 
        "data-is-closed": isClosedOrder, 
        "data-first-short-date": "", 
        "data-last-date": "", 
        "data-last-short-date": "", 
        "data-order-id": order.id, 
        "data-batch-number": order.batchNumber, 
        "data-is-selected": isOrderSelected, 
        style: {
          backgroundColor: get(order, 'styleBeer.color', ''),
          opacity: '0.6',
          transition: 'width 0s',
          fontWeight: '600',
          cursor: SessionStore.isAbleToEditDates() ? 'pointer' : 'default'
        }, 
        ref: order.id, 
        key: order.id, // position: i
        _grid: {
          i: order.id,
          minW: 1,
          maxW: 1,
          x: ContentUtils.getColumnsByCombinedOrderForFermenting(context.state, xPosition),
          y: fermenterHY.y,
          w: 1,
          h: fermenterHY.h + 1,
          batchNumber: get(order, 'batchNumber'),
          static: isOrderStatic
        }}, 
        isVisibleBeerStyleLabelFermenting && React.createElement(OrderBeerStyleLabel, {order: order}), 
        fermenterTasksEl
      ));
  }
  if (orderHY && context.state.isVisiblePackagingSection) {
    const xPosition = +order.briteTank.column;
    elements.push(
      React.createElement("div", {
        onTouchTap: BrowserUtils.isIpad() ? onDoubleClickOrder : null, 
        onDoubleClick: onDoubleClickOrder, 
        onContextMenuCapture: openRightButtonContextMenu, 
        className: classNameBT + (packagingTasksIsHighLighted ? ' is-filter-active' : ''), 
        "data-x": xPosition, 
        "data-y": orderHY.y, 
        "data-tank-type": 'BT', 
        "data-some-product-confirmed": isSomeProductConfirmed, 
        "data-is-closed": isClosedOrder, 
        "data-first-date": "", 
        "data-first-short-date": "", 
        "data-last-date": "", 
        "data-last-short-date": "", 
        "data-order-id": order.id, 
        "data-batch-number": order.batchNumber, 
        "data-is-selected": isOrderSelected, 
        style: {
          backgroundColor: get(order, 'styleBeer.color'),
          opacity: '0.6',
          transition: 'width 0s',
          fontWeight: '600',
          cursor: SessionStore.isAbleToEditDates() ? 'pointer' : 'default'
        }, 
        ref: order.id + '_BT', 
        key: order.id + '_BT', // position: i
        _grid: {
          i: order.id + '_BT',
          minW: 1,
          maxW: 1,
          x: ContentUtils.getColumnsByCombinedOrderForPackaging(context.state, xPosition),
          y: orderHY.y,
          w: 1,
          h: orderHY.h + 1,
          batchNumber: get(order, 'batchNumber'),
          static: isOrderStatic
        }}, 
        isVisibleBeerStyleLabelPackaging && React.createElement(OrderBeerStyleLabel, {order: order}), 
        packagingTasksEl
      ));
  }

  return elements;
}

const OrderBeerStyleLabel = React.createClass({displayName: "OrderBeerStyleLabel",
  render() {
    const { order } = this.props;
    const shouldDark = ContentUtils.getColorByBgColor(get(order, 'styleBeer.color')).indexOf('#000') > -1;
    return (
      React.createElement("div", {
        "data-first-date": "", 
        "data-first-short-date": "", 
        "data-last-date": "", 
        "data-last-short-date": "", 
        "data-order-id": order.id, 
        "data-batch-number": order.batchNumber, 
        style: {
          color: shouldDark ? 'black' : 'white'
        }, 
        className: "beer-style-label"}, get(order, 'styleBeer.name')
      )
    );
  }
});

function getIconSize() {
  const isOpenPackaging = UIStateStore.isPackagingNotesBarOpen();
  const isBrewingNotesBarOpen = UIStateStore.isBrewingNotesBarOpen();

  if (isBrewingNotesBarOpen && isOpenPackaging) {
    return 'small';
  }

  if ((!isBrewingNotesBarOpen && isOpenPackaging) || (isBrewingNotesBarOpen && !isOpenPackaging)) {
    return 'medium';
  }

  if (!isBrewingNotesBarOpen && !isOpenPackaging) {
    return 'large';
  }
}

function openContextMenuRightClick(tankClicked, order, evt) {
  if (evt) {
    // we need to stop propagation in order to avoid bubbling this event and will
    // be captured with the listener of empty cell of Dashboard.
    evt.stopPropagation();
    // just avoid to show default context menu of browser.
    evt.preventDefault();

    AppDispatcher.dispatch({
      type: ActionTypes.RIGHT_DOUBLE_CLICK_DASHBOARD_OCCUPIED,
      order,
      tankClicked,
      dateClicked: ChronologycStore.getDateFromClientY(evt.clientY),
      positionX: evt.clientX,
      positionY: evt.clientY,
      isBrewingTankClicked: get(tankClicked, 'type') === 'BH'
    });
  }
}

function openRightButtonContextMenu(evt) {
  const orderId = evt.currentTarget.getAttribute('data-order-id');
  const orderSelected = OrderStore.getOrder(orderId);
  const tankType = evt.currentTarget.getAttribute('data-tank-type');
  const isSingle = evt.currentTarget.getAttribute('data-is-single');
  const tankClicked = isSingle ? orderSelected.singleTank : tankType === 'FV' ? orderSelected.fermenterTank : orderSelected.briteTank;

  openContextMenuRightClick(tankClicked, orderSelected);
}

function openContextMenuRightClickFromBrewhouse(tankClicked, order, evt) {
  // we need to stop propagation in order to avoid bubbling this event and will
  // be captured with the listener of empty cell of Dashboard.
  //evt.stopPropagation();
  // just avoid to show default context menu of browser.
  evt.preventDefault();

  if (!SessionStore.isAbleToEditDates()) {
    Notification.show(t('dashboard_notification_dont_enough_permission_section'));
  }

  AppDispatcher.dispatch({
    type: ActionTypes.RIGHT_DOUBLE_CLICK_DASHBOARD_OCCUPIED_BREWHOUSE,
    order,
    batchNumber: get(order, 'batchNumber'),
    tankClicked,
    dateClicked: ChronologycStore.getDateFromClientY(evt.clientY),
    positionX: evt.clientX,
    positionY: evt.clientY,
    tankType: 'BH'
  });
}

/**
 * The event handler of click an order.
 * NOTE: this method is required to set Dashboard Component context before to use it.
 * @argument {Event} evt the event from the order.
 */
function onDoubleClickOrder(evt) {
  ContextMenuEl.close();
  evt.preventDefault();
  evt.stopPropagation();
  evt.nativeEvent.stopImmediatePropagation();

  const isMobile = BrowserUtils.isMobileNonCareIPad();
  if (isMobile) {
    return;
  }

  const orderEl = ContentUtils.getComponentByAttribute(evt.target, 'data-tank-type');
  const orderId = evt.currentTarget.getAttribute('data-order-id');
  const orderSelected = OrderStore.getOrder(orderId);
  const tankType = orderEl.getAttribute('data-tank-type');
  const dateRow = ChronologycStore.getDateFromClientY(evt.clientY);
  const tankClicked = DashboardStore.getTankFromClientX(evt.clientX);
  const isFermenterTank = JSON.parse(orderEl.classList.contains('is-fermenter'));

  // this are needed in order to complete position that currently are not visible

  AppDispatcher.dispatch({
    type: ActionTypes.LEFT_DOUBLE_CLICK_DASHBOARD_OCCUPIED,
    existingOrderInfo: {
      orderSelected,
      tankClicked,
      dateRow,
      isFermenterTank,
      tankType
    }
  });

}

/**
 * Clean orders selected.
 * @param {HTMLElement} dashboardEl
 */
function _clearOrderSelected(dashboardEl) {
  if (dashboardEl) {
    const ordersSelectedEl = dashboardEl.querySelectorAll('div[data-is-selected=true]');
    OrderStore.updateLastOrderUpdated(null);
    if (ordersSelectedEl) {
      forEach(ordersSelectedEl, function (el) {
        el.classList.remove('animated');
        el.setAttribute('data-is-selected', 'false');
      });
    }
  }
}

/**
 * Highlight given order id from the dashboard and update the dashboard component state.
 * @param {HTMLElement} el          The order element that are selected.
 * @param {String}      id          The order id. (Optionally)
 * @private
 */
function _markOrders(el, id) {
  if (!el) {
    return;
  }

  let orderId = ContentUtils.cleanId(id || el.getAttribute('data-order-id')),
    dashboardEl = ContentUtils.getComponentByClassName(el, 'react-grid-layout'),
    ordersEl;

  if (!dashboardEl) {
    return;
  }

  // retrieve the order to take batch number
  const order = OrderStore.getOrder(orderId);
  OrderStore.updateLastOrderUpdated(order);

  if (order && !order.batchNumber) {
    ordersEl = dashboardEl.querySelectorAll('div[data-order-id="' + orderId + '"]');
  } else if (order) {
    ordersEl = dashboardEl.querySelectorAll('div[data-batch-number="' + order.batchNumber + '"]');
  }

  // Clean before selection order.
  _clearOrdersSelection(el);

  if (ordersEl && ordersEl.length > 0) {
    forEach(ordersEl, function (el) {
      //el.classList.add('selected');
      el.classList.add('animated');
      el.setAttribute('data-is-selected', 'true');
    });
  }
}

/**
 * Clear all height light of the order in the dashboard.
 * @param context
 * @private
 */
function _clearOrdersSelection(context, onFinish) {
  const dashboardEl = ContentUtils.getComponentByClassName(context, 'react-grid-layout');

  if (dashboardEl) {
    const lastElSelected = dashboardEl.querySelectorAll('div[data-is-selected=true]');
    if (lastElSelected) {
      forEach(lastElSelected, function (el) {
        //el.classList.remove('selected');
        el.classList.remove('animated');
        el.setAttribute('data-is-selected', 'false');
      });
    }
  }

  if (onFinish) {
    onFinish();
  }
}

function drawBrewhouseBatchs(state, order, context) {
  if (order && order.batchs) {
    let batchsEl = [];
    // in case which some product are confirmed, the order will be frizzed

    forEach(order.batchs, batch => {
      const tankHY = _calculateHY(state.from, state.to, batch.date, batch.date);
      const isSomeProductConfirmed = OrderUtils.haveSomeProductConfirmed(batch);
      const isStaticOrder = DashboardStore.isPublishingDraft() || isSomeProductConfirmed || !context.state.isAbleToEditDates;
      if (tankHY && state.isVisibleBrewingSection) {
        batchsEl.push(_drawBatch(state, order, tankHY, batch, state.from, context, isStaticOrder, isSomeProductConfirmed));
      }
    });
    return batchsEl;
  }
}

function drawIconAndLabel(
  order,
  task,
  fromDashboard,
  tankType,
  itemFiltered,
  maxScopeInventoryDate,
  isCalculatingInventory,
  minDateInventory
) {
  if (!order || !task) {
    return;
  }

  // The vertical distance of pixels from date reference to the icon & label position.
  const iconYPosition = _getYIconPosition(task, order, fromDashboard, tankType);

  // display elements
  const isHighlighted = DateUtils.isAfter(task.date, minDateInventory) && isCalculatingInventory
    ? InventoryStore.someItemsExistInGivenTask(task, itemFiltered)
    : false;
  const labelEl = _getIconLabel(task, order, iconYPosition, tankType);
  const iconEl = SessionStore.isFullPaidVersion() && isCalculatingInventory
    ? _getIconEl(task, order, iconYPosition, tankType, isHighlighted, maxScopeInventoryDate)
    : _getIconElFreeVersion(task, order, iconYPosition, tankType);
  const {
    amountSubtracted,
    amountItemNeeded,
    amountPurchased
  } = isCalculatingInventory ? InventoryStore.getTotalAmountReservedByItem(task, ContentUtils.getItemId(itemFiltered)) : {
    amountItemReserved: 0,
    amountItemNeeded: 0
  };
  return (
    React.createElement("div", {className: "order-icon"}, 
      isHighlighted && NumberUtils.isGreater(amountItemNeeded, 0) ? getInventoryMissingStatusEL(get(itemFiltered, 'description'), amountItemNeeded, iconYPosition) : null, 
      isHighlighted && NumberUtils.isGreater(amountSubtracted, 0) ? getInventoryStatusEL(get(itemFiltered, 'description'), amountSubtracted, iconYPosition) : null, 
      isHighlighted && NumberUtils.isGreater(amountPurchased, 0) ? getInventoryRequestedStatusEL(get(itemFiltered, 'description'), amountPurchased, iconYPosition) : null, 
      React.createElement("div", {className: "order-icon-top"}, 
        labelEl
      ), 
      React.createElement("div", {className: "order-icon-bottom"}, 
        iconEl
      )
    )
  );
}

function getInventoryStatusEL(itemDescription, amount, iconYPosition) {
  return (
    React.createElement("span", {className: "order-icon-inventory-status"}, 
      React.createElement("span", {className: "order-icon-inventory-status__amount", 
        style: {
          transform: `translateY(${iconYPosition})`
        }
      }, amount)
    )
  );
}

function getInventoryMissingStatusEL(itemDescription, amount, iconYPosition) {
  return (
    React.createElement("span", {className: "order-icon-inventory-status"}, 
      React.createElement("span", {className: "order-icon-inventory-missing-status__amount", 
        style: {
          transform: `translateY(${iconYPosition})`
        }
      }, amount)
    )
  );
}

function getInventoryRequestedStatusEL(itemDescription, amount, iconYPosition) {
  return (
    React.createElement("span", {className: "order-icon-inventory-status"}, 
      React.createElement("span", {className: "order-icon-inventory-requested-status__amount", 
        style: {
          transform: `translateY(${iconYPosition})`
        }
      }, amount)
    )
  );
}

function _getYIconPosition(task, order, fromDashboard, tankType) {
  const isBrewingBatch = tankType === 'BH' && task.turnId;
  if (isBrewingBatch) {
    // enter here means is the batch so don't more than 1 row height
    return '0px';
  }

  // the first date of the order an generic way
  const fromDate = ContentUtils.getOrderField(order, 'startDate', tankType);

  // ask which is first date top of the order or top of dashboard visible (in case as partial show order)
  const dateReference = DateUtils.isBefore(fromDate, fromDashboard) ? fromDashboard : fromDate;

  // calculate the amount of days of the order
  const daysRangeFromTask = DateUtils.getDaysBetween(dateReference, task.date);

  const iconYPosition = (daysRangeFromTask * ROW_HIGHT) + 'px';
  return iconYPosition;
}

function _getIconLabel(icon, order, iconYPosition, tankType) {
  return icon.label ? (
    React.createElement("i", {className: "order-icon-top-label", 
      "data-tank-type": tankType, 
      "data-order-id": order.id, 
      "data-batch-number": order.batchNumber, 
      style: {
        transform: `translateY(${iconYPosition})`,
        width: 'inherit !important'
      }}, 
      icon.label
    )) : null;
}

function _getIconEl(task, order, iconYPosition, tankType, isIconHighLighted, maxScopeInventoryDate) {
  const iconInfo = _getIconInfo(tankType, task);
  const iconClassName = `${get(iconInfo, 'icon.icon')} ${get(iconInfo, 'iconClassName')}`;
  const isEnoughStockItems = task.someItemsIsNotEnoughInStock === false;
  const haveEnoughPurchaseItem = task.someItemsIsNotEnoughInPurchase === false;
  return iconClassName ? (
    React.createElement("span", {
      className: 'dashboard-icon stop-dragging filtration-icon center-icon-small text-center icon-task ' + iconClassName + (isIconHighLighted ? ' is-icon-highlighted' : ''), 
      "data-order-id": order.id, 
      "data-batch-number": order.batchNumber, 
      "data-dashboard-width": getIconSize(), 
      "data-is-inventory-task": InventoryStore.haveAProducts(task), 
      "data-inventory-status-icon-state": InventoryStore.getInventoryStatusFromTask(task, maxScopeInventoryDate), 
      "data-is-inventory-scheduled": isEnoughStockItems, 
      "data-is-already-purchase-items": haveEnoughPurchaseItem, 
      style: {
        transform: `translateY(${iconYPosition})`,
        width: 'inherit !important',
        visibility: (task.name === TASK_NON_VISIBLE) ? 'hidden' : 'inherit'
      }
    }
    )
  ) : null;
}

function _getIconElFreeVersion(task, order, iconYPosition, tankType) {
  const iconInfo = _getIconInfo(tankType, task);
  const iconClassName = `${get(iconInfo, 'icon.icon')} ${get(iconInfo, 'iconClassName')}`;
  return iconClassName ? (
    React.createElement("span", {
      className: 'dashboard-icon stop-dragging icon-task filtration-icon center-icon-small text-center ' + iconClassName, 
      "data-order-id": order.id, 
      "data-batch-number": order.batchNumber, 
      "data-dashboard-width": getIconSize(), 
      style: {
        transform: `translateY(${iconYPosition})`,
        width: 'inherit !important',
        visibility: (task.name === TASK_NON_VISIBLE) ? 'hidden' : 'inherit'
      }
    }
    )
  ) : null;
}

function _getIconInfo(tankType, task) {
  return DashboardServiceCache.hydrateWithIcon(task, tankType, 'dashboard',
    tankType === 'FV'
      ? DashboardServiceCache.getFermenterIconsWithLegacy()
      : tankType === 'BT'
        ? DashboardServiceCache.getPackagingIconsWithLegacy()
        : DashboardServiceCache.getBrewhouseIconsWithLegacy()
  );

}

function isStaticBatchOrder(isStaticOrder, order, self) {
  return isStaticOrder || DashboardStore.isPublishingDraft() ? true : get(order, 'closed') ? true : SessionStore.isAdminUser() ? false : true;
}

function _drawBatch(state, order, tankHY, batch, from, self, isStaticOrder, isSomeProductConfirmed) {
  const isVisibleBeerStyleLabelBrewing = state.isVisibleBeerStyleLabelBrewing;
  const isStatic = state.isGuestUser
    ? true
    : isStaticBatchOrder(isStaticOrder, order, self);
  order.isBHAllowed = true; // just to be sure, set isBHAllowed in true otherwise this drawing operation not make sense.
  order.currentSection = 'BH'; // just to open tab of order modal properly
  const column = +get(batch, 'turn.column');
  const isClosedOrder = get(order, 'closed');
  const currentTank = DashboardServiceCache.getTankByColumn(column);
  const orderId = order.id;
  const orderIdWithPrefix = order.id + '_BH';
  const tankType = 'BH';
  // This is necessary because react grid layout set new positions when
  // you do double click, and will cause side effects
  self.positions.stop = null;
  self.positions.start = null;

  const isCurrentLastOrderChanged = ContentUtils.cleanId(order.id) === ContentUtils.cleanId(get(OrderStore.getLastOrderUpdate(), 'id'));
  let className = isCurrentLastOrderChanged ? 'order-style is-last-order-changed' : 'order-style';

  // draw the icon and label elements
  const filterItem = get(state, 'filterItem');
  const iconEl = drawIconAndLabel(
    order,
    batch,
    from,
    tankType,
    filterItem,
    state.maxScopeInventoryDate,
    state.isCalculatingInventory,
    state.minDateInventory
  );

  const onRightClick = evt => {
    openContextMenuRightClickFromBrewhouse(currentTank, order, evt);
  }; // do nothing in brewhouse section

  const isOrderSelected = order.id === get(OrderStore.getLastOrderUpdate(), 'id');
  const isSearchExpand = get(state, 'isSearchExpand') || get(state, 'isFilterModeActivated');
  const isHighLighted = isSearchExpand ? InventoryStore.isSomeItemInTasks(get(order, 'batchs'), filterItem) : false;

  return (
    React.createElement("div", {
      onDoubleClick: onDoubleClickOrder, 
      onTouchTap: BrowserUtils.isIpad() ? onDoubleClickOrder : null, 
      className: className + (isHighLighted ? ' is-filter-active' : ''), 
      onContextMenuCapture: onRightClick, 
      "data-tank-type": tankType, 
      "data-some-product-confirmed": isSomeProductConfirmed, 
      "data-is-closed": isClosedOrder, 
      "data-first-date": "", 
      "data-first-short-date": "", 
      "data-last-date": "", 
      "data-last-short-date": "", 
      "data-order-id": orderId, 
      "data-x": column, 
      "data-y": tankHY.y, 
      "data-batch-number": order.batchNumber, 
      "data-is-selected": isOrderSelected, 
      style: {
        backgroundColor: get(order, 'styleBeer.color'),
        opacity: '0.6',
        transition: 'width 0s',
        fontWeight: '600',
        cursor: SessionStore.isAbleToEditDates() ? 'pointer' : 'default'
      }, 
      key: orderIdWithPrefix + '|' + column + '|' + batch.date, 
      _grid: {
        verticalCompact: true,
        isResizable: false,
        // initialize in false this flag, because will be useful when
        // need to know in Brewhouse store, which position are already
        // re-located, in order to know if are available that position
        // or not.
        isRelocated: false,
        minW: 1,
        maxW: 1,
        x: column,
        y: tankHY.y,
        w: 1,
        h: tankHY.h + 1,
        i: orderId,
        batchNumber: get(order, 'batchNumber'),
        static: isStatic
      }
    }, 
      isVisibleBeerStyleLabelBrewing && React.createElement(OrderBeerStyleLabel, {order: order}), 
      iconEl
    )
  );
}

function drawSingleOrder(order, from, to, context) {
  const isSomeProductConfirmed = OrderUtils.haveSomeProductConfirmed(OrderUtils.getTaskFromOrder(order));
  const isOrderPartiallyOutSideOfDashboardRange = !OrderUtils.isOrderInRange(from, to, order);
  const isStatic = context.state.isGuestUser
    ? true
    : isOrderPartiallyOutSideOfDashboardRange
      ? true
      : !context.state.isAbleToEditDates;


  const isVisibleBeerStyleLabelFermenting = context.state.isVisibleBeerStyleLabelFermenting;
  const isVisibleBeerStyleLabelPackaging = context.state.isVisibleBeerStyleLabelPackaging;

  if (!order.singleTank) {
    //console.warn('***** SINGLE ORDER TANK NULL:' + JSON.stringify(order));
    return null;
  }
  let elements = [],
    tankHY = _calculateHY(from, to, order.fromDate, order.toDate);

  if (!tankHY) {
    return elements;
  }

  const isCurrentLastOrderChanged = ContentUtils.cleanId(order.id) === ContentUtils.cleanId(get(OrderStore.getLastOrderUpdate(), 'id'));
  order.currentSection = get(order, 'singleTank.type');

  const tankType = get(order, 'singleTank.type'),
    tankTypeConfiguration = ContentUtils.getTankTypeConfiguration(tankType);

  const itemFiltered = get(context, 'state.filterItem');
  const singleIcons = filter(order.singleTasks, taskFilter => DateUtils.isAfterOrEquals(taskFilter.date, from) && DateUtils.isBeforeOrEquals(taskFilter.date, to));
  const singleIconsSorted = DateUtils.sortListByDateField(singleIcons, 'date');
  const singleIconsEl = map(singleIconsSorted, singleTask =>
    drawIconAndLabel(
      order,
      singleTask,
      from,
      order.currentSection,
      get(context, 'state.filterItem'),
      get(context, 'state.maxScopeInventoryDate'),
      get(context, 'state.isCalculatingInventory'),
      get(context, 'state.minDateInventory')
    ));
  let className = tankTypeConfiguration.className + ' order-style';
  const isHighLighted = get(context, 'state.isSearchExpand') || get(context, 'state.isFilterModeActivated') ? InventoryStore.isSomeItemInTasks(order.singleTasks, itemFiltered) : false;

  if (isCurrentLastOrderChanged) {
    className += ' is-last-order-changed';
  }

  if (isOrderPartiallyOutSideOfDashboardRange) {
    className += ' is-partially-out-side-of-dashboard';
  }

  const isClosedOrder = get(order, 'closed') === true;
  const isOrderSelected = order.id === get(OrderStore.getLastOrderUpdate(), 'id');
  const elID = order.id + get(tankTypeConfiguration, 'postFix');

  const {
    isVisibleBrewingSection,
    isVisibleFermentingSection,
    isVisiblePackagingSection
  } = context.state;

  if (
    isVisibleBrewingSection && tankType === 'BH' ||
    isVisibleFermentingSection && tankType === 'FV' ||
    isVisiblePackagingSection && tankType === 'BT'
  ) {

    const column = ContentUtils.getNewColumnSingleBySection(order, context.state.tanks, {
      isVisibleBrewingSection,
      isVisibleFermentingSection,
      isVisiblePackagingSection
    });

    elements.push(
      React.createElement("div", {
        onContextMenuCapture: openRightButtonContextMenu, 
        onDoubleClick: onDoubleClickOrder, 
        onTouchTap: BrowserUtils.isIpad() ? onDoubleClickOrder : null, 
        className: className + (isHighLighted ? ' is-filter-active' : ''), 
        "data-tank-type": tankType, 
        "data-first-date": "", 
        "data-some-product-confirmed": isSomeProductConfirmed, 
        "data-is-closed": isClosedOrder, 
        "data-first-short-date": "", 
        "data-last-date": "", 
        "data-is-single": true, 
        "data-last-short-date": "", 
        "data-order-id": order.id, 
        "data-volume": order.volume, 
        "data-is-selected": isOrderSelected, 
        "data-batch-number": order.batchNumber, 
        style: {
          backgroundColor: get(order, 'styleBeer.color'),
          opacity: '0.6',
          transition: 'width 0s',
          fontWeight: '600',
          cursor: SessionStore.isAbleToEditDates() ? 'pointer' : 'default'
        }, 
        ref: elID, 
        key: elID, 
        _grid: {
          minW: 1,
          maxW: 1,
          x: column,
          y: tankHY.y,
          w: 1,
          h: tankHY.h + 1,
          i: elID,
          batchNumber: get(order, 'batchNumber'),
          volume: get(order, 'volume'),
          static: isStatic
        }
      }, 
        tankType === 'FV' && isVisibleBeerStyleLabelFermenting && React.createElement(OrderBeerStyleLabel, {order: order}), 
        tankType === 'BT' && isVisibleBeerStyleLabelPackaging && React.createElement(OrderBeerStyleLabel, {order: order}), 
        singleIconsEl
      )
    );
  }

  return elements;
}

function getToggleShowInventoryButtonEl(isPublishButtonVisible, isSearchExpand, iconDisableShowInventory) {
  return React.createElement("div", {className: "btn-calculate-inventory with-opacity"}, 
    React.createElement(FloatingActionButton, {
      ref: "btnSearch", 
      onClick: this._onToggleCalculateInventory, 
      className: "btn-right-upload btn-search with-opacity hidden-xs", 
      iconClassName: "muidocs-icon-action-grade", 
      backgroundColor: this.state.isCalculatingInventory ? '#0288d1' : '#B3B3B3'}, 
      iconDisableShowInventory
    )
  );
}

/**
 * Calculate the first position of date (the vertical initial position, `Y`) and their height (`H`) in the current layout of dashboard.
 *
 * @param {StringDate} from          The first current date that show the dashboard.
 * @param {StringDate} to            The last current date that show the dashboard.
 * @param {StringDate} fromBox       The current from target date.
 * @param {StringDate} toBox         The current to target date.
 * @returns {{y: *, h: *}}
 * @private
 */
function _calculateHY(from, to, fromBox, toBox) {
  var i = -1,
    y,
    h,
    dateValidate,
    firstDate = DateUtils.toDate(from);

  if (DateUtils.isBefore(toBox, from) || DateUtils.isAfter(fromBox, to)) {
    // Enter here means that this part of the order should not be render because is out of range of dashboard.
    return null;
  }

  while (true) {
    i++;
    dateValidate = DateUtils.addDaysTextBasicFormat(firstDate, i);
    if (fromBox === dateValidate) {
      y = i;
    }

    if (toBox === dateValidate || DateUtils.isAfter(dateValidate, to) || DateUtils.isEqual(dateValidate, to)) {
      if (!y) {
        // Enter here means that boxFrom is before of dashboard 'from', so we define the first position of dashboard
        // in order to draw only a part of the order.
        y = 0;
      }

      h = (i - y);
      break;
    }
  }

  if (!h) {
    // Enter here means that toBox date is after of dashboard range 'to'.
    h = (i - y);
  }

  return {
    y: y,
    h: h
  };
}

function onClickTryProVersion() {
  const self = this;
  DashboardServiceImpl.changeFreeToProVersion(() => {
    delay(() => {
      DashboardActionCreators.forceReFetchAndRenderDashboard(self.state.from, self.state.to);
      window.location.reload(true);
    }, 1000);
  });
}


module.exports = Dashboard;



/** WEBPACK FOOTER **
 ** ./src/views/Dashboard/Dashboard.jsx
 **/